
import SetFxRateDialog from '@/components/Domain.FxRates/SetFxRateDialog.vue';
import CreateFxRateButton from '@/components/Domain.FxRates/CreateFxRateButton.vue';
export default {
    components: { SetFxRateDialog, CreateFxRateButton },
    props: {
        value: Boolean,
    },
};
